var _rect, _rect2, _rect3, _rect4, _rect5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 32,
    height: 22,
    rx: 4,
    fill: "#A5D6A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.82324,
    y: 1,
    width: 26.3529,
    height: 1.83333,
    fill: "#388E3C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.82324,
    y: 21.1665,
    width: 26.3529,
    height: 1.83333,
    fill: "#388E3C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 20.25,
    width: 16.5,
    height: 1.88235,
    transform: "rotate(-90 0 20.25)",
    fill: "#388E3C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.1172,
    y: 20.25,
    width: 16.5,
    height: 1.88235,
    transform: "rotate(-90 30.1172 20.25)",
    fill: "#388E3C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.9996,
    cy: 12,
    rx: 5.64706,
    ry: 5.5,
    fill: "#388E3C"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.29412,
    cy: 4.20833,
    rx: 3.29412,
    ry: 3.20833,
    fill: "#388E3C"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.58816,
    cy: 12.0001,
    rx: 1.88235,
    ry: 1.83333,
    fill: "#388E3C"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.4116,
    cy: 12.0001,
    rx: 1.88235,
    ry: 1.83333,
    fill: "#388E3C"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.29412,
    cy: 19.7916,
    rx: 3.29412,
    ry: 3.20833,
    fill: "#388E3C"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7062,
    cy: 4.20833,
    rx: 3.29412,
    ry: 3.20833,
    fill: "#388E3C"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7062,
    cy: 19.7918,
    rx: 3.29412,
    ry: 3.20833,
    fill: "#388E3C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 23,
    rx: 3.5,
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCash);
export default __webpack_public_path__ + "static/media/IconCash.8d2f1e90.svg";
export { ForwardRef as ReactComponent };